import './tabOneView.scss';
import pencilImage from '../../../assets/icons/pencil.png';
import ViewInformationPills from '../pills/viewInformationPills';
import ModificationComplete from '../modificationComplete/modificationComplete';
import { useNavigate, useNavigation } from 'react-router-dom';
import { IEmpInfoData } from 'types/listOfEmployees';
import { phoneNumberAddHypen } from 'constants/utils';
import moment from 'moment';

interface IProps {
  empData: IEmpInfoData | null;
  infoData: IEmpInfoData | null;
  managerEditableEmpInfo: boolean;
}

const TabOneView = ({ empData, infoData, managerEditableEmpInfo }: IProps) => {
  const navigate = useNavigate();
  if (!infoData) return null;
  return (
    <div className="memberViewInfoTabOne">
      <div className="personalInfo">
        <div className="headingDark">계정정보</div>

        <div className="label">핸드폰 번호</div>
        <div className="value">{phoneNumberAddHypen(infoData?.MobileNo ?? '')}</div>
        <br />
        {moment(infoData?.BIRTHDATE).isValid() && (
          <>
            <div className="label">생년월일</div>
            <div className="value">{moment(empData?.BIRTHDATE).format('YYYY.MM.DD')}</div>
          </>
        )}
      </div>

      <div className="accountInfo">
        <div className="headingWithSettings">
          <div className="headingDark-type2">인사정보</div>
          {managerEditableEmpInfo && (
            <button
              className="settingsWrapper"
              onClick={() => {
                navigate('/work-schedule', {
                  state: {
                    empData: infoData,
                    formType: '인사정보',
                  },
                });
              }}>
              <img src={pencilImage} alt="" className="pencilImage" />
              수정
            </button>
          )}
        </div>

        <div className="label">입사~퇴사일</div>
        <div className="value">
          {moment(infoData.START).format('YYYY.MM.DD')} ~{' '}
          {infoData.END === null ? '계속' : moment(infoData.END).format('YYYY.MM.DD')}
        </div>
        <br />
        <div className="label">직책</div>
        <div className="value">{infoData.IS_MANAGER === '1' ? '매니저' : '스태프'}</div>
        <br />

        <div className="pillWrapper">
          <div className="pillContainerLabel">권한</div>

          <div className="pillContainer">
            {infoData.IS_MANAGER === '0' ? (
              infoData.PAY_SHOW === '1' ? (
                <ViewInformationPills text={'본인급여 확인가능'} />
              ) : (
                <div className="emptyArea" style={{ marginTop: 10, textAlign: 'left' }}>
                  <span className="emptyText">적용 권한 없음</span>
                </div>
              )
            ) : (
              <>
                {infoData.PAY_SHOW === '0' &&
                infoData.STOREPAY_SHOW === '0' &&
                infoData.OTHERPAY_SHOW === '0' &&
                infoData.CalendarEdit === '0' &&
                infoData.PUSH === '0' ? (
                  <div className="emptyArea" style={{ marginTop: 10, textAlign: 'left' }}>
                    <span className="emptyText">적용 권한 없음</span>
                  </div>
                ) : (
                  <>
                    {infoData.PAY_SHOW === '1' && <ViewInformationPills text={'본인급여 확인가능'} />}
                    {infoData.STOREPAY_SHOW === '1' && <ViewInformationPills text={'사업장급여 확인가능'} />}
                    {infoData.OTHERPAY_SHOW === '1' && <ViewInformationPills text={'직원급여/일정확인 및 수정가능 '} />}
                    {infoData.CalendarEdit === '1' && <ViewInformationPills text={'출퇴근기록 수정가능'} />}
                    {infoData.PUSH === '1' && <ViewInformationPills text={'타직원 출퇴근 알람받기'} />}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabOneView;
